<div class="w-full h-full max-h-[800px]  bg-dat-grey-100 overflow-y-scroll">
    @for (eventInfo of eventInfo(); track eventInfo.trackId) {
    <iq-builder-diagram-builder
        [title]="eventInfo.id"
        [triggerEvents]="eventInfo.events"
    ></iq-builder-diagram-builder>
    }
</div>
